/* TRUSTED Constants */
export const TRUSTED = {
    SET: "TRUSTED:SET",
    SET_DEVICE: "TRUSTED:SET_DEVICE",
    PREFIX: "trusted_",
    DELAY_MS: 60000,
};
